// @flow

import _ from 'lodash/fp';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import validator from '../../helpers/validator';
import {touch, isValid, getFormValues} from 'redux-form';
import {
  closeApartmentDeviation,
  addApartmentDeviation,
  updateApartmentDeviation,
} from '../../actions/apartmentView';
import ModalDialog from '../../components/ModalDialog/ModalDialog';
import ApartmentDeviationForm from '../../components/ApartmentDeviationForm/ApartmentDeviationForm';

const apartmentDeviationValidation = {
  id: {rule: 'numeric|required', label: 'Avvikelsetyp'},
  reason: {rule: 'string|required', label: 'Beskrivning'},
};

export type Props = {
  active: ?any,
  show: boolean,
  deviations: any[],
  apartmentDeviations: any[],
  apartmentDeviationFormIsValid: boolean,
  apartmentDeviationFormValues: any,
  closeApartmentDeviation: Function,
  addApartmentDeviation: Function,
  updateApartmentDeviation: Function,
  touch: Function,
};

class ApartmentDeviationDialogContainer extends Component<Props> {
  props: Props;
  onSaveDevationRelation() {
    const {
      active,
      apartmentDeviationFormValues,
      apartmentDeviationFormIsValid,
      touch,
      addApartmentDeviation,
      updateApartmentDeviation,
      closeApartmentDeviation,
    } = this.props;
    const apartmentDeviationKeys = _.keys(apartmentDeviationValidation);
    touch('apartmentDeviation', ...apartmentDeviationKeys);
    if (!apartmentDeviationFormIsValid) {
      return;
    }

    if (active) {
      updateApartmentDeviation(active.id, apartmentDeviationFormValues);
    } else {
      addApartmentDeviation(apartmentDeviationFormValues);
    }

    closeApartmentDeviation();
  }

  render() {
    const {
      active,
      show,
      deviations,
      apartmentDeviations,
      closeApartmentDeviation,
    } = this.props;

    return (
      <div>
        <ModalDialog
          onClose={() => closeApartmentDeviation()}
          show={show}>
          <ApartmentDeviationForm
            initialValues={active}
            deviations={deviations}
            apartmentDeviations={apartmentDeviations}
            validate={values => validator(apartmentDeviationValidation, values)} />
          <button
            type="button"
            className="expanded button"
            onClick={() => this.onSaveDevationRelation()}>
            {active ? 'Uppdatera' : 'Lägg till'}
          </button>
          <button
            type="button"
            className="expanded button"
            onClick={() => closeApartmentDeviation()}>
              Avbryt
          </button>
        </ModalDialog>
      </div>
    );
  }
}

const mapStateToProps = ({
  apartmentView: {
    apartment: {
      deviations: apartmentDeviations,
    },
    deviation: {
      active,
      show,
    },
    deviations: {
      list: deviations,
    },
  },
  form,
}) => ({
  active,
  show,
  deviations,
  apartmentDeviations,
  apartmentDeviationFormIsValid: isValid('apartmentDeviation')({form}),
  apartmentDeviationFormValues: getFormValues('apartmentDeviation')({form}),
});

const mapDispatchToProps = dispatch => ({
  closeApartmentDeviation: () =>
    dispatch(closeApartmentDeviation()),
  addApartmentDeviation: deviation =>
    dispatch(addApartmentDeviation(deviation)),
  updateApartmentDeviation: (id, deviation) =>
    dispatch(updateApartmentDeviation(id, deviation)),
  touch: (form, ...fields) =>
    dispatch(touch(form, ...fields)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApartmentDeviationDialogContainer);



// WEBPACK FOOTER //
// ./src/containers/ApartmentDeviationDialogContainer/ApartmentDeviationDialogContainer.js